import React from "react";
import styles from "./Copyright.module.scss";
import { Linkedin } from "react-bootstrap-icons";

const Copyright: React.FC = () => {
  return (
    <div className={styles.copyright}>
      <div className={styles.copyright__container}>
        <div className={styles.copyright__container__links}>
          <div className={styles.copyright__container__links__item}>
            <p className={styles.copyright__container__links__item__title}>
              © {new Date().getFullYear()} Mkrtich Okroyan
            </p>
            <div className={styles.copyright__container__links__item__social}>
              <a
                className={
                  styles.copyright__container__links__item__social__links
                }
                href="www.linkedin.com/in/mkrtich-okroyan-826b8020b"
              >
                <Linkedin
                  className={
                    styles.copyright__container__links__item__social__links__icon
                  }
                  width={30}
                  height={30}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
